// src/components/pages/chi-sono/ChiSono.tsx
import React from 'react';
import './ChiSono.css';

// Import immagini (aggiorna i percorsi in base alla struttura reale)
import annImage from '../../../assets/images/chi-sono/annalisa-main.jpg';
import missionImage from '../../../assets/images/chi-sono/mission.jpg';
import valuesImage from '../../../assets/images/chi-sono/valori.jpg';
import { Button } from 'react-bootstrap';

const ChiSono: React.FC = () => {
  return (
    <div className="chi-sono-container">
      {/* Hero Section */}
      <section className="chi-sono-hero-section py-5">
        <div className="container">
          <div className="row align-items-center min-vh-60 py-5">
            <div className="col-lg-6">
              <div className="chi-sono-hero-content">
                <h1 className="chi-sono-hero-title display-3 fw-bold mb-4">
                  <span className="text-primary">Chi sono</span>
                  <br />
                  <span className="text-gradient-secondary">
                    Annalisa, la tua guida al benessere posturale
                  </span>
                </h1>
                <p className="chi-sono-hero-description lead text-muted mb-4">
                  Da più di 20 anni aiuto le persone a ritrovare il benessere
                  attraverso la riconnessione con il proprio corpo, il respiro,
                  perfino con il battito cardiaco.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="chi-sono-hero-image text-center">
                <div className="main-image-placeholder">
                  <img
                    src={annImage}
                    alt="Annalisa - Formatrice di Benessere Posturale"
                    className="img-fluid rounded-3 shadow-lg"
                    style={{ maxWidth: '100%', border: '8px solid white' }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sezione Chi Sono */}
      <section className="chi-sono-content-section py-5 bg-light">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-10">
              <div className="card border-0 shadow-sm rounded-3 overflow-hidden">
                <div className="row g-0">
                  <div className="col-md-6 p-4 p-lg-5 d-flex flex-column justify-content-center">
                    <div className="chi-sono-header mb-4">
                      <h2 className="card-title display-5 fw-bold mb-3 text-primary">
                        CHI SONO
                      </h2>
                      <div className="chi-sono-content">
                        <p className="card-text mb-3 fw-semibold">
                          Classe 1976.
                        </p>
                        <p className="card-text mb-3">
                          Appartengo a quelli che hanno vissuto il cambio
                          epocale da un millennio a un altro. Sono cresciuta con
                          Bim Bum Bam, ho seguito al Tg il Rivoltoso di Piazza
                          Tienanmen e la caduta del muro di Berlino, manifestato
                          contro la guerra del Golfo ... poi sono arrivati i
                          Nokia 3310, poi Facebook e tutto il resto! Ho visto
                          trasformarsi ogni cosa a ritmo incalzante.
                        </p>
                        <p className="card-text mb-3 fw-semibold">
                          Io stessa sono diventata "trasformazione".
                        </p>
                        <p className="card-text mb-3">
                          La vita va sempre più di fretta, il mondo del lavoro
                          ha perso ogni punto fermo e si è capovolto, chi non si
                          aggiorna perde il passo, ma ...
                        </p>
                        <p className="card-text mb-3 fw-bold text-secondary">
                          la Salute resta ancora la cosa più importante!
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="chi-sono-image h-100">
                      <img
                        src={valuesImage}
                        alt="Il mio percorso di trasformazione"
                        className="img-fluid h-100"
                        style={{ objectFit: 'cover', minHeight: '400px' }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sezione Formazione e Percorso */}
      <section className="chi-sono-experience-section py-5 bg-white">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-10">
              <div className="card border-0 shadow-sm rounded-3 overflow-hidden mb-5">
                <div className="card-body p-4 p-lg-5">
                  <div className="row">
                    <div className="col-lg-8">
                      <p className="card-text mb-4">
                        Anche nel campo della salute l'innovazione ha fatto
                        passi da gigante, tuttavia è negli insegnamenti più
                        antichi che ho ritrovato le conoscenze più valide per
                        mantenersi sani il più a lungo possibile: restare in
                        contatto con la natura (e quindi selezionare i cibi più
                        sani e meno lavorati), continuare a fare movimento
                        (quello corretto e rispettoso delle nostre condizioni),
                        non smettere mai di imparare a conoscersi per potersi
                        prendere cura di sé nel modo più amorevole.
                      </p>

                      <h3 className="h4 fw-bold mb-3 text-primary">
                        La mia passione per il movimento
                      </h3>
                      <p className="card-text mb-4">
                        Ho sempre avuto la passione di sentire muovere il mio
                        corpo in modo armonioso e sono stata insegnante di
                        danza, di psicomotricità, di ginnastica dolce, di
                        Jazzercise (un rivoluzionario programma di fit-dance e
                        totalbody workout ideato dall'americana Judi Sheppard
                        nel 1969 ... ho un certo richiamo per le rivoluzioni!),
                        di Mammafit e di Pancafit, ho perfino ideato lo
                        "Stretching dello Zodiaco".
                      </p>
                    </div>
                    <div className="col-lg-4">
                      <div className="chi-sono-stats p-3 bg-primary bg-opacity-10 rounded-3 h-100">
                        <h4 className="h5 fw-bold mb-3 text-secondary">
                          Le mie formazioni
                        </h4>
                        <ul className="list-unstyled">
                          <li className="d-flex align-items-start mb-2">
                            <i className="bi bi-check-circle-fill text-primary me-2 mt-1"></i>
                            <span>
                              5 anni - Naturopata specializzata in Naturopatia
                              Vibrazionale e Kinesiologia
                            </span>
                          </li>
                          <li className="d-flex align-items-start mb-2">
                            <i className="bi bi-check-circle-fill text-primary me-2 mt-1"></i>
                            <span>
                              1 anno - Terapista Pancafit per il riequilibrio
                              posturale ad approccio globale
                            </span>
                          </li>
                          <li className="d-flex align-items-start mb-2">
                            <i className="bi bi-check-circle-fill text-primary me-2 mt-1"></i>
                            <span>1 anno - Insegnante di Hatha Yoga</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="mt-4 p-3 bg-success bg-opacity-10 rounded-3">
                    <p className="mb-0 fw-bold">
                      Insegno a sentire e a controllare i muscoli (anche quelli
                      più nascosti, come il diaframma e il pavimento pelvico,
                      invisibili e importantissimi!), a gestire il respiro e di
                      conseguenza le emozioni, ma la mia priorità è rendere le
                      persone consapevoli della propria postura per essere in
                      grado di auto-correggersi: questa è la mia vocazione e ne
                      ho fatto la mia missione!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sezione Missione */}
      <section className="chi-sono-mission-section py-5 bg-dark text-white chi-sono-final-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-10">
              <div className="card border-0 shadow-sm rounded-3 overflow-hidden bg-dark text-white">
                <div className="row g-0 flex-md-row-reverse">
                  <div className="col-md-6 p-4 p-lg-5 d-flex flex-column justify-content-center">
                    <div className="chi-sono-mission-header mb-4">
                      <h2 className="card-title display-5 fw-bold mb-3 text-primary">
                        MISSIONE: Formatrice di Ben-Essere
                      </h2>
                      <div className="chi-sono-mission-content">
                        <p className="card-text mb-3 fw-bold text-white">
                          Nei miei video-corsi non trovi i soliti allenamenti.
                          In realtà non sono nemmeno allenamenti.
                        </p>
                        <p className="card-text mb-3 text-white">
                          Cerco di offrirti qualcosa di più prezioso: le
                          istruzioni che occorrono{' '}
                          <span className="text-secondary fw-bold">PRIMA</span>{' '}
                          di svolgere qualunque movimento. Sono delle conoscenze
                          che tutti avremmo dovuto avere fin da subito.
                        </p>
                        <p className="card-text mb-3 text-white">
                          Alcune di queste "istruzioni" ci arrivano troppo
                          tardi, quando ormai abbiamo utilizzato in modo
                          sbagliato il nostro corpo, procurandoci dei danni.
                          Quando il professionista di turno cerca di
                          aggiustarci, ci rivela quali movimenti non possiamo
                          più fare e, ogni tanto, quali non avremmo dovuto fare.
                        </p>
                        <p className="card-text mb-3 fw-bold text-secondary">
                          Ma se avessimo avuto questi consigli PRIMA di
                          sbagliare?
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="chi-sono-mission-image h-100">
                      <img
                        src={missionImage}
                        alt="La mia missione: educazione al movimento corretto"
                        className="img-fluid h-100"
                        style={{ objectFit: 'cover', minHeight: '400px' }}
                      />
                      <div className="text-center image-caption mt-3">
                        <small className="text-secondary">
                          Insegno cosa fare e come farlo.
                        </small>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Seconda parte della missione */}
                <div className="row g-0 mt-3">
                  <div className="col-12 p-4 p-lg-5">
                    <div className="chi-sono-mission-details">
                      <h3 className="h4 fw-bold mb-3 text-primary">
                        Ecco, questo è esattamente il mio lavoro:
                      </h3>
                      <p className="card-text mb-4 text-white">
                        Partendo da una valutazione posturale (globale e
                        approfondita), ti insegno come ottenere il recupero
                        posturale e come muoverti in modo corretto nella
                        quotidianità o quando ti alleni.
                      </p>
                      <div className="row mb-4">
                        <div className="col-md-6">
                          <div className="p-3 bg-primary bg-opacity-10 rounded-3 h-100">
                            <h4 className="h5 fw-bold mb-2 text-secondary">
                              Se hai un trauma:
                            </h4>
                            <p className="mb-0 small text-white">
                              Ti serve uno specialista per fare terapia.
                            </p>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="p-3 bg-primary bg-opacity-10 rounded-3 h-100">
                            <h4 className="h5 fw-bold mb-2 text-secondary">
                              Se vuoi prevenire:
                            </h4>
                            <p className="mb-0 small text-white">
                              Posso insegnarti l'educazione al movimento
                              corretto.
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="p-4 bg-primary bg-opacity-10 rounded-3 text-center">
                        <p className="mb-2 fw-bold text-white">
                          Con queste conoscenze potrai sentire il tuo corpo e
                          assumere Tu il controllo dei tuoi movimenti. Non sarà
                          più la gravità a modificare la tua postura portando
                          tutto verso il basso!
                        </p>
                        <h4 className="display-6 fw-bold text-secondary mt-3">
                          In 4 parole, con queste conoscenze potrai VIVERE A
                          TESTA ALTA!
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sezione Valori */}
      <section className="chi-sono-values-section py-5 bg-white">
        <div className="container">
          <div className="row justify-content-center mb-5">
            <div className="col-12 col-lg-10 text-center">
              <h2 className="display-5 fw-bold mb-3 text-primary">
                I miei valori
              </h2>
              <p className="lead text-muted">
                I principi che guidano il mio lavoro quotidiano
              </p>
            </div>
          </div>

          <div className="row g-4 justify-content-center">
            {/* Valore 1 */}
            <div className="col-md-6 col-lg-4">
              <div className="chi-sono-value-card card h-100 border-0 shadow-sm p-4">
                <div className="card-body text-center">
                  <div className="chi-sono-value-icon display-4 text-primary mb-3">
                    <i className="bi bi-heart-pulse"></i>
                  </div>
                  <h3 className="chi-sono-value-title h4 fw-bold mb-3">
                    Consapevolezza Posturale
                  </h3>
                  <p className="chi-sono-value-description text-muted">
                    Insegnare alle persone a riconoscere la propria postura e ad
                    auto-correggersi, diventando protagonisti attivi del proprio
                    benessere.
                  </p>
                </div>
              </div>
            </div>

            {/* Valore 2 */}
            <div className="col-md-6 col-lg-4">
              <div className="chi-sono-value-card card h-100 border-0 shadow-sm p-4">
                <div className="card-body text-center">
                  <div className="chi-sono-value-icon display-4 text-primary mb-3">
                    <i className="bi bi-lightbulb"></i>
                  </div>
                  <h3 className="chi-sono-value-title h4 fw-bold mb-3">
                    Educazione Preventiva
                  </h3>
                  <p className="chi-sono-value-description text-muted">
                    Fornire le "istruzioni per l'uso" del corpo PRIMA che si
                    verifichino problemi, per prevenire danni e mantenere la
                    salute a lungo termine.
                  </p>
                </div>
              </div>
            </div>

            {/* Valore 3 */}
            <div className="col-md-6 col-lg-4">
              <div className="chi-sono-value-card card h-100 border-0 shadow-sm p-4">
                <div className="card-body text-center">
                  <div className="chi-sono-value-icon display-4 text-primary mb-3">
                    <i className="bi bi-shield-check"></i>
                  </div>
                  <h3 className="chi-sono-value-title h4 fw-bold mb-3">
                    Approccio Olistico
                  </h3>
                  <p className="chi-sono-value-description text-muted">
                    Unire conoscenze antiche e moderne, considerando la persona
                    nella sua interezza: corpo, respiro, emozioni e movimento.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="chi-sono-cta-section py-5 bg-dark text-white chi-sono-final-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-8 text-center">
              <h2 className="display-5 fw-bold mb-4">
                Pronto a vivere a testa alta?
              </h2>
              <p className="lead mb-4 text-white">
                Scopri come posso aiutarti a sviluppare la consapevolezza
                posturale e imparare a muoverti in modo corretto nella tua
                quotidianità.
              </p>
              <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center">
                <Button
                  variant="secondary"
                  size="lg"
                  className="cta-btn"
                  as="a"
                  href="/servizi"
                >
                  SCOPRI I MIEI SERVIZI
                </Button>

                <Button
                  variant="outline-secondary"
                  size="lg"
                  className="cta-btn"
                  as="a"
                  href="/rimettiti-al-centro"
                >
                  SCOPRI I MIEI VIDEOCORSI
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ChiSono;
